import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import BLOG_ARTICLES  from "../data/blogPosts";
import BlogPost from "./BlogPost";
import NotFound from "./NotFound";

export default function CatchAllOldBlog() {
  const { pathname } = useLocation();
  const isBlogPath = pathname.startsWith("/blog/");
  const slug = pathname.replace(/^\/blog\//, "").replace(/^\/|\/$/g, "");

  const isBP = BLOG_ARTICLES.some((p) => p.slug.replace(/^\/|\/$/g, "") === slug);

  if (isBP && isBlogPath) return <BlogPost />;
  if (isBP) return <Navigate to={`/blog/${slug}`} replace />;

  // Genuinely unknown URL: render a real 404 page instead of redirecting home.
  return <NotFound />;
}
